import { devLog } from "../../utils/devLog";

export const CONTINUE_TEXT_W_LANG = {
  en_US: "Continue in English",
  ar_AE: "استمر بالعربية",
  es_ES: "Continuar en español",
  es_LA: "Continuar en español",
  fr_FR: "Continuer en français",
  pt_BR: "Continue em portugues",
  pt_PT: "Continue em portugues",
  iw_IL: "המשך בעברית"
};

export const CONTINUE_TEXT = {
  en_US: "Continue",
  ar_AE: "يكمل",
  es_ES: "Continuar",
  es_LA: "Continuar",
  fr_FR: "Continuez",
  pt_BR: "Continuar",
  pt_PT: "Continuar",
  iw_IL: "לְהַמשִׁיך"
};

// These greetings deliberately live here rather than in Messages.js: each
// button must read in its OWN language whatever the active locale is, which
// react-intl cannot do.
//
// The maps above are hand-written, but a facility's supportedLocales come from
// the open-ended DEFAULT_LOCALES master data behind the MPS-admin picker, so a
// facility can be configured with a locale that has no entry here. Falling back
// to the language's own name keeps the button readable to the people it is for
// instead of rendering an empty pill.
const getLanguageName = locale => {
  let tag = locale.replace("_", "-");
  try {
    return new Intl.DisplayNames([tag], { type: "language" }).of(tag) || tag;
  } catch (e) {
    return tag;
  }
};

export const getContinueText = (locale, withLang) => {
  if (!locale) {
    return "";
  }
  let text = withLang ? CONTINUE_TEXT_W_LANG[locale] : CONTINUE_TEXT[locale];
  if (text) {
    return text;
  }
  devLog(
    "[SignupIntro] no hand-written continue text for locale",
    locale,
    "- falling back to the language name"
  );
  return getLanguageName(locale);
};
